<div class="header">
  <h3>{{'NORMAL.DOWN' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row align-items-center">
    <div class="col-md-6 form-group">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="customerCode" [options]="customerCode" [(ngModel)]="selectedCustomercode"
          [autoDisplayFirst]="false" placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}" [style]="{'z-index': 3}"
          filter="true">
        </p-dropdown>
        <label for="customerCode">{{'FILTER.CUSTOMER-CODE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-6 m-t-10 form-group">
      <div class="dropdown-label-group">

        <p-multiSelect
          class="dv-dropdown"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [panelStyle]="{minWidth: '520px'}"
          [defaultLabel]="defaultLabel"
        >
        </p-multiSelect>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchText" [(ngModel)]="documentNumber"
               placeholder="{{ 'FILTER.DOCUMENT-NUMBER' | translate }}">
        <label for="month">{{ "FILTER.DOCUMENT-NUMBER" | translate }}</label>
      </div>
    </div>
    <div class="col-md-6 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="email" [(ngModel)]="email"
               placeholder="{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}">
        <label for="searchText">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</label>
      </div>
    </div>
    <div class="col-md-6 m-t-10 form-group">
      <div class="form-label-group">
        <input class="form-control" type="text" id="poNumber" [(ngModel)]="poNumber"
               placeholder="{{ 'FILTER.PO-NUMBER' | translate }}">
        <label for="searchText">{{ 'FILTER.PO-NUMBER' | translate }}</label>
      </div>
    </div>
    <div class="col-md-6 m-t-10 form-group">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="วันที่" readonly>
          <label for="calendarDropdown">{{'NORMAL.REQ-DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <div class="row">
    <div class="col-md-6">
      <app-custom-pagination [(currentPage)]="currentPage" [(itemsPerPage)]="itemsPerPage" [totalItems]="totalItems"
                             (pageChange)="pageChanged()" (optionChange)="optionChanged()">
      </app-custom-pagination>
    </div>
    <div class="col-md-6 text-right">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="!rejectedList.length"
              (click)="open(rejectModal)">{{ 'NORMAL.REJECT' | translate }}</button>
      <button type="button" class="btn btn-dv btn-wide" [disabled]="!approvedList.length"
              (click)="open(confirmModal)">{{ 'NORMAL.APPROVE' | translate }}</button>
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="!loading">
      <thead>
      <tr>
        <th scope="col">{{ 'NORMAL.QUE' | translate }}</th>
        <th scope="col">{{ 'FILTER.CUSTOMER-CODE' | translate }}</th>
        <th scope="col">{{ 'FILTER.DOCUMENT-TYPE' | translate }}</th>
        <th scope="col">{{ 'TABLE.DOCUMENT-NUMBER' | translate }}</th>
        <th scope="col">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</th>
        <th scope="col">{{ 'FILTER.PO-NUMBER' | translate }}</th>
        <th scope="col">{{ 'FILTER.DATE' | translate }}</th>
        <th>
          <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="isCheckAll" (click)="checkAll()"></p-checkbox>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let document of documentList; let index = index">
        <td>{{ index + 1 }}</td>
        <td>{{ document.customer_code || '-' }}</td>
        <td>{{ document.rd_doc_type_display || '-' }}</td>
        <td>{{ document.document_number || '-' }}</td>
        <td>{{ document.email }}</td>
        <td>{{ document.po_number }}</td>
        <td>{{ document.document_start_date }} {{'FILTER.CALENDAR.TO' | translate}} {{ document.document_end_date }}</td>
        <td>
          <p-checkbox class="dv-checkbox" [(ngModel)]="document.status" binary="true"
                      (onChange)="toggleStatusChange()"></p-checkbox>
          <a href="javascript:void(0)" (click)="deleteDownloadRequest(document.id)">
            <i class="fa fa-trash"></i>
          </a>
        </td>
      </tr>
      <tr *ngIf="!documentList.length">
        <td colspan="6" class="text-center"><h5>{{'NORMAL.NO-RE' | translate}}</h5></td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #confirmModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="d('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!showResults; else completed">
      {{'NORMAL.APPROVAL-PENDING' | translate}} {{ approvedList.length }} {{'NORMAL.ORDER' | translate}} ?
    </div>
    <ng-template #completed>
      <div *ngIf="successEmailList.length">
        <p>{{'NORMAL.MAIL-APPROVAL-SENT' | translate}}</p>
        <ul>
          <li *ngFor="let email of successEmailList">{{ email }}</li>
        </ul>
      </div>
      <div *ngIf="failedEmailList.length">
        <p>{{'NORMAL.MAIL-FAILED' | translate}}</p>
        <ul>
          <li *ngFor="let email of failedEmailList">{{ email }}</li>
        </ul>
      </div>
    </ng-template>
  </div>
  <div class="modal-footer" *ngIf="!showResults">
    <button type="button" class="btn btn-dv btn-wide" (click)="confirm()">
      <i *ngIf="isLoadingConfirm === true" class="fa fa-spinner fa-spin m-r-5"></i>
      <i *ngIf="isLoadingConfirm === false" class="fa fa-check m-r-5"></i>
      {{'NORMAL.CON' | translate}}
    </button>
    <div class="row m-b-5">
      <div class="col text-center text-red">{{errorMessage ? errorMessage : '&nbsp;' }}</div>
    </div>
  </div>
</ng-template>

<ng-template #rejectModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" (click)="d('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!showResults; else completed">
      {{'NORMAL.REJECTION-PENDING' | translate}} {{ rejectedList.length }} {{'NORMAL.ORDER' | translate}} ?
    </div>
    <ng-template #completed>
      <div *ngIf="successEmailList.length">
         <p>{{'NORMAL.MAIL-REJECTION-SENT' | translate}}</p>
        <ul>
          <li *ngFor="let email of successEmailList">{{ email }}</li>
        </ul>
      </div>
      <div *ngIf="failedEmailList.length">
        <p>{{'NORMAL.MAIL-FAILED' | translate}}</p>
        <ul>
          <li *ngFor="let email of failedEmailList">{{ email }}</li>
        </ul>
      </div>
    </ng-template>
  </div>
  <div class="modal-footer" *ngIf="!showResults">
    <button type="button" class="btn btn-dv btn-wide" (click)="reject()">
      <i *ngIf="isLoadingConfirm === true" class="fa fa-spinner fa-spin m-r-5"></i>
      <i *ngIf="isLoadingConfirm === false" class="fa fa-check m-r-5"></i>
      {{'NORMAL.CON' | translate}}
    </button>
    <div class="row m-b-5">
      <div class="col text-center text-red">{{errorMessage ? errorMessage : '&nbsp;' }}</div>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.html